<template>
  <v-dialog v-model="showOptOutDialog" persistent max-width="600px">
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
         <v-chip
            text-color="white"
            :color="responseColor"
            small
            v-on="on"
            v-on:click="handleClick"
            close
            :close-icon="actionIcon"
            @click:close="handleClick"
          >
            <v-avatar>
              <refresh-spinner v-show="loading" v-model="loading"></refresh-spinner>
              <v-icon
                v-show="!loading"
                >{{ responseIcon }}</v-icon>
            </v-avatar>
            &nbsp;<slot></slot>
         </v-chip>
        </template>
        <span>{{ suppressionStatus }}</span>
        <br>
        <span>Click to {{ isSuppressed ? 'OPT-IN' : 'OPT-OUT' }} Address</span>
      </v-tooltip>
    </template>
    <v-card>
      <template v-if="!isSuppressed">
        <v-card-title>
          <span class="text-h5">Opt Out of future campaigns</span>
          <v-spacer></v-spacer>
          <refresh-spinner v-show="isSubmittingData" v-model="isSubmittingData"></refresh-spinner>
        </v-card-title>
        <v-card-text>
          <read-only-field label="Address" :value="value.address" :loading="loading"/>
          <v-switch v-model="optOutAllDealers">
            <template v-slot:label>
              Opt-Out Address for All Dealers
            </template>
          </v-switch>
          <v-select
            v-model="optOutReason"
            :items="optOutReasons"
            hint="Reason for OptOut"
            persistent-hint
          ></v-select>
          <v-text-field
            v-model="optOutReasonOther"
            v-show="optOutReasonIsOther"
            outlined
            label="Other - Please explain why customer Opted-Out"
            class="mt-6"
          >
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="resetOptOut">Cancel</v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="!canOptOut"
            @click="submitSuppression"
          >
            Opt-Out
          </v-btn>
        </v-card-actions>
      </template>
      <!-- IS SUPPRESSED -->
      <template v-else>
        <v-card-title>
          <span class="text-h5">Opt-In Address</span>
          <v-spacer></v-spacer>
          <refresh-spinner v-show="isSubmittingData" v-model="isSubmittingData"></refresh-spinner>
        </v-card-title>
        <v-card-text>
          <read-only-field label="Address" :value="value.address" :loading="loading"/>
          <v-switch v-model="optOutAllDealers">
            <template v-slot:label>
              Opt-In Address for All Dealers
            </template>
          </v-switch>
       </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="resetOptOut">Cancel</v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="submitAppend"
          >
            Opt-IN
          </v-btn>
        </v-card-actions>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import RefreshSpinner from '@/components/ui/RefreshSpinner'
import ReadOnlyField from '@/components/ui/ReadOnlyField'
import { mapState } from 'vuex'
import { hasValue } from '@/utils'
import { path } from 'ramda'

export default {
  name: 'address-suppression-chip',
  props: {
    value: {
      required: true,
      type: Object
    },
    customerId: {
      type: Number,
      required: true
    }
  },
  components: {
    [ReadOnlyField.name]: ReadOnlyField,
    [RefreshSpinner.name]: RefreshSpinner
  },
  data: function () {
    return {
      loading: false,
      suppressionResponse: {},
      showOptOutDialog: false,

      optOutReason: '',
      optOutAllDealers: true,
      optOutDealerId: null,
      optOutReasons: [
        'Customer Emailed Dealer asking to be UnSubscribed',
        'Customer Called Dealer asking to be UnSubscribed',
        'Other'
      ],
      optOutReasonOther: null,
      isSubmittingData: false
    }
  },
  computed: {
    ...mapState('DealerStore', { dealer: 'dealer' }),
    ...mapState('CustomerAppendsStore', { customerAppends: 'customerAppends' }),
    ...mapState({
      accountKey: state => path(['attributes', 'custom:account_key'], state.cognito.user),
      currentUserEmail: state => path(['attributes', 'email'], state.cognito.user),
      currentUserName: state => path(['attributes', 'name'], state.cognito.user)
    }),
    addressAppends () {
      return this.customerAppends.find(ca => ca.append_type === 'address' && ca.midp_a === this.value.midp_a) || {}
    },
    suppressionReason () {
      return this.addressAppends.message
    },
    isSuppressed () {
      return this.addressAppends.append_action === 'suppress' || this.value.is_suppressed
    },
    suppressionStatus () {
      if (this.isSuppressed) {
        return `Suppressed because [${this.suppressionReason}].`
      } else {
        return 'Valid and not suppressed.'
      }
    },
    responseIcon () {
      if (this.loading) {
        return 'mdi-timer-sand-empty'
      } else {
        return this.isSuppressed ? 'mdi-home-alert' : 'mdi-home'
      }
    },
    responseColor () {
      if (this.loading) {
        return 'grey'
      } else {
        return this.isSuppressed ? 'red' : 'green'
      }
    },
    actionIcon () {
      if (this.loading) {
        return 'mdi-timer-sand-empty'
      } else {
        return this.isSuppressed ? 'mdi-plus-outline' : 'mdi-close-outline'
      }
    },
    optOutReasonIsOther () {
      return this.optOutReason === 'Other'
    },
    canOptOut () {
      return !this.isSuppressed &&
        (
          (this.optOutReasonIsOther && hasValue(this.optOutReasonOther)) ||
          (!this.optOutReasonIsOther && hasValue(this.optOutReason))
        )
    }
  },
  methods: {
    handleClick (data) {
      if (this.loading) {
        return
      }
      this.showOptOutDialog = true
    },
    submitSuppression () {
      this.isSubmittingData = true

      const userPart = `ExecutedBy: ${this.currentUserName} [${this.currentUserEmail}]`
      const reason = this.optOutReasonIsOther
        ? `R4: ${this.optOutReason}: ${this.optOutReasonOther} - ${userPart}`
        : `R4: ${this.optOutReason} - ${userPart}`

      this.$store.dispatch('CustomerAppendsStore/saveCustomerAppends', {
        append_action: 'suppress',
        append_type: 'address',
        account_id: this.accountKey,
        customer_id: this.customerId,
        dealer_id: this.optOutAllDealers ? null : this.dealer.dms_key,
        address_id: Number(this.value.address_id),
        message: reason
      })
        .then(resp => {
          this.isSubmittingData = false
          this.resetOptOut()
        })
        .catch(error => {
          this.$logger.error('Unable to opt out customer.', error.message)
          this.isSubmittingData = false
          this.$flash({
            showClose: true,
            message: 'Unable to opt out customer. ' + error.message,
            type: 'error',
            duration: 0
          })
        })
    },
    submitAppend () {
      this.isSubmittingData = true

      const userPart = `ExecutedBy: ${this.currentUserName} [${this.currentUserEmail}]`
      const reason = `R4: OptIn - ${userPart}`

      this.$store.dispatch('CustomerAppendsStore/saveCustomerAppends', {
        append_action: 'append',
        append_type: 'address',
        account_id: this.accountKey,
        customer_id: this.customerId,
        dealer_id: this.optOutAllDealers ? null : this.dealer.dms_key,
        address_id: Number(this.value.address_id),
        message: reason
      })
        .then(resp => {
          this.isSubmittingData = false
          this.resetOptOut()
        })
        .catch(error => {
          this.$logger.error('Unable to opt out customer.', error.message)
          this.isSubmittingData = false
          this.$flash({
            showClose: true,
            message: 'Unable to opt out customer. ' + error.message,
            type: 'error',
            duration: 0
          })
        })
    },
    resetOptOut () {
      this.showOptOutDialog = false
      this.optOutAllDealers = true
      this.optOutReason = null
      this.optOutDealerId = null
      this.optOutReasonOther = null
    }

  }
}
</script>
